module.exports = __webpack_public_path__ + "img/helm_of_the_undying.70ead437.png";